import { Injectable } from '@angular/core';
import { FirestoreService } from './firestore.abstract.service';
import { User } from '../models/user';
import { Firestore, FirestoreDataConverter } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class UserService extends FirestoreService<User> {


  protected basePath = 'user';
  // private blogData: Blog[] = JSON.parse(JSON.stringify(blogDataJson));

  constructor(firestore: Firestore) {
    super(firestore);
  }

  /**
   * Overide this on each class
   * @returns FirestoreDataConverter<any>
   */
  // Override the getConverter method to provide custom toFirestore and fromFirestore methods
  override getConverter(): FirestoreDataConverter<any> {
    return {
      // Convert User object to Firestore-compatible format
      toFirestore: (user: User) => {
        let userData = {
          uid: user.uid,
          email: user.email,
          name: user.name,
          createdAt: user.createdAt ? user.createdAt : new Date().toISOString(),
          updatedAt: new Date().toISOString(),
          emailVerified: user.emailVerified || false,
          avatarUrl: user.avatarUrl,
          providerData: user.providerData,
          providerId: user.providerId
        };
        userData = this.removeEmpty(userData); // Remove any empty/null values
        return userData;
      },
      // Convert Firestore snapshot to User object
      fromFirestore: (snapshot: any, options: any) => {
        const data = snapshot.data(options);
        return new User(data);
      },
    };
  }

}
